import { render, staticRenderFns } from "./SponsorshipTrade.vue?vue&type=template&id=49fd2259&"
import script from "./SponsorshipTrade.vue?vue&type=script&lang=js&"
export * from "./SponsorshipTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports